import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EducationalwebviewComponent } from './educationalwebview.component';

const routes: Routes = [
  {
    path: 'education/view/:id',
    component: EducationalwebviewComponent
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EducationalwebviewRoutingModule { }
